//# sourceMappingURL=my-weekday.interface.js.map


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/mydatepicker/dist/interfaces/my-weekday.interface.js
// module id = ../../../../mydatepicker/dist/interfaces/my-weekday.interface.js
// module chunks = 4